(() => {
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');

  const initReveal = root => {
    const items = root.querySelectorAll('[data-reveal]');
    if (!items.length || !('IntersectionObserver' in window)) return;
    root.classList.add('has-js');
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      observer.unobserve(entry.target);
    }), { rootMargin: '0px 0px -10% 0px' });
    items.forEach(item => observer.observe(item));
  };

  // Roll-fold brochure: closed or fully open (the CSS unfolds the cover, then the inner flap). Back side only when closed.
  const STATUS = { closed: 'Couverture', open: 'Brochure ouverte', back: 'Dos : accès, horaires et contact' };

  const initFold = fold => {
    if (fold.dataset.ready) return;
    fold.dataset.ready = 'true';
    const rig = fold.querySelector('[data-fold-rig]');
    const status = fold.querySelector('[data-fold-status]');
    const toggle = fold.querySelector('[data-fold-toggle]');
    const flip = fold.querySelector('[data-fold-flip]');
    const menu = fold.querySelector('[data-fold-menu]');
    let open = false;
    let side = 'front';

    const render = () => {
      fold.dataset.open = String(open);
      fold.dataset.side = side;
      status.textContent = side === 'back' ? STATUS.back : open ? STATUS.open : STATUS.closed;
      toggle.firstChild.textContent = open ? 'Fermer la brochure' : 'Ouvrir la brochure';
      toggle.setAttribute('aria-pressed', String(open));
      flip.hidden = open;
      flip.textContent = side === 'back' ? 'Voir la couverture' : 'Voir le dos';
    };
    let closing;
    const setOpen = value => {
      // While closing, the CSS delays the cover so the inner flap folds back first.
      fold.classList.toggle('is-closing', !value);
      clearTimeout(closing);
      if (!value) closing = setTimeout(() => fold.classList.remove('is-closing'), 1600);
      open = value;
      if (open) side = 'front';
      render();
    };

    toggle.addEventListener('click', () => setOpen(!open));
    flip.addEventListener('click', () => {
      if (open) return;
      side = side === 'back' ? 'front' : 'back';
      render();
    });
    rig.addEventListener('click', () => {
      if (side === 'back') { side = 'front'; render(); return; }
      setOpen(!open);
    });
    // 'Voir la carte' unrolls the drinks menu below the brochure and scrolls to it.
    menu?.addEventListener('click', event => {
      const card = document.getElementById(menu.getAttribute('href').slice(1));
      if (!card) return;
      event.preventDefault();
      card.open = true;
      card.scrollIntoView({ behavior: reduced.matches ? 'auto' : 'smooth', block: 'start' });
      card.querySelector('summary')?.focus({ preventScroll: true });
    });

    // A small invitation the first time the brochure scrolls into view: the cover lifts, then settles.
    if ('IntersectionObserver' in window && !reduced.matches) {
      const peek = new IntersectionObserver(entries => entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        peek.disconnect();
        setTimeout(() => {
          if (open || side !== 'front') return;
          fold.classList.add('is-peeking');
          setTimeout(() => fold.classList.remove('is-peeking'), 900);
        }, 450);
      }), { threshold: .6 });
      peek.observe(rig);
    }
    render();
  };

  const init = (scope = document) => {
    scope.querySelectorAll('[data-le15]').forEach(initReveal);
    scope.querySelectorAll('[data-fold]').forEach(initFold);
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
